import { getV3dProcedures } from '../../v3d-utils/get-v3d-procedures';
import { keyframeGroups } from '../fading/shared-animation-data';

export const continueGearAnimation = () => {
  // console.log(keyframeGroups.gears);
  // getV3dProcedures().resumeAnimations(keyframeGroups.gears);
  getV3dProcedures().resumeAnimationsFromTo(keyframeGroups.gears, 0, 201, 1);
};
